import { render, staticRenderFns } from "./DynamicText.vue?vue&type=template&id=53efe50c&scoped=true&"
import script from "./DynamicText.vue?vue&type=script&lang=js&"
export * from "./DynamicText.vue?vue&type=script&lang=js&"
import style0 from "./DynamicText.vue?vue&type=style&index=0&id=53efe50c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efe50c",
  null
  
)

export default component.exports